import { createApi } from '@reduxjs/toolkit/query/react';
import { getApiBaseUrl } from '../../../Features/API/api';
import { baseQueryWithReauth } from '../../../Features/API/baseQueryWithReauth';

const BASE_URL = getApiBaseUrl();

/**
 * Technician portal RTK Query slice.
 *
 * Hits the Bureau_jobcard adapter endpoints (/api/jobs, /api/branches,
 * /api/clients, /api/vehicles, /api/stock, /api/branch-stock,
 * /api/technician-stock, /api/stock-transfer-requests).
 *
 * Endpoints are added incrementally per phase:
 *   Phase 4B: jobs (list, detail, create, patch, delete) + branches/clients/vehicles reads
 *   Phase 4C: photo upload via media_manager
 *   Phase 4D: my-stock + transfer requests
 */
export const technicianApiSlice = createApi({
  reducerPath: 'technicianApi',
  baseQuery: baseQueryWithReauth(BASE_URL),
  tagTypes: [
    'Job',
    'Vehicle',
    'Branch',
    'Client',
    'Technician',
    'StockConfiguration',
    'TechnicianStock',
    'BranchStock',
    'StockTransferRequest',
  ],
  endpoints: (builder) => ({
    // Phase 4B will populate this with real endpoints. Empty for now so the
    // slice registers cleanly in store.js and dashboard renders without errors.
  }),
});

export default technicianApiSlice;
